import { LoggedLayoutService } from "@puntaje/shared/cui"
import { Component, OnInit, Input } from "@angular/core"
import { Router, ActivatedRoute } from "@angular/router"
import { AuthService, SessionService } from "@puntaje/shared/core"
import { AppConfig } from "@puntaje/shared/core"
declare const config: AppConfig
import { Usuario, Usuarios } from "@puntaje/puntaje/api-services"

@Component({
    templateUrl: "home.component.html",
    styleUrls: ["home.component.scss"]
})
export class HomeComponent implements OnInit {
    config: typeof config
    @Input() pagina: string = "home"
    isPro = false
    dias = false
    dias_faltantes = 0
    frase: string = ""
    mailSinConfirmar: boolean = false
    showMisCarreras: boolean = false || config.plataforma.showMisCarreras
    //@ViewChild('loadingLayout') loadingLayout: LoadingLayoutComponent;
    asignaturasBoxInsteadPlanClase = false

    showcases = config.app.showcasesByApp?.[config.app.name] || [
        {
            nombre: "Datos Usuario",
            identificador: "usuario-showcasebox",
            columna: 0,
            orden: 0
        },
        {
            nombre: "Notificaciones",
            identificador: "notificaciones-showcasebox",
            columna: 1,
            orden: 0
        },
        {
            nombre: "Noticias",
            identificador: "noticias-alumnos-showcasebox",
            columna: 1,
            orden: 1
        },
        {
            nombre: "Banners",
            identificador: "arte-home-showcasebox",
            columna: 2,
            orden: 1
        },
        {
            nombre: "Ensayos Mensuales",
            identificador: "ensayos-mensuales",
            columna: 2,
            orden: 0
        }
    ]

    showcasesColumna = this.showcases
        .sort((s1, s2) => s1.orden - s2.orden)
        .reduce((acc, showcase) => {
            acc[showcase.columna] = acc[showcase.columna] || []
            acc[showcase.columna].push(showcase)

            return acc
        }, {})

    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        private authService: AuthService,
        protected sessionService: SessionService,
        protected usuariosService: Usuarios,
        protected loggedLayoutService: LoggedLayoutService
    ) {
        this.config = config
    }

    ngOnInit() {
        this.isPro = this.sessionService.isPro()
        this.setMailSinConfirmar()

        this.loggedLayoutService.setOptions({ freeContentStyle: true, noTitleBar: true })
    }

    setMailSinConfirmar() {
        const confirmed_at = this.sessionService.getConfirmedAt()
        if (!confirmed_at) {
            this.mailSinConfirmar = true
        }
    }
}
